import React from 'react';

export const unexpectedServerErrorMsg = (
  <span>
    Something went wrong during the signup process. Try again or contact{' '}
    <a
      href="https://support.xmatters.com/hc/en-us/requests/new"
      target="_blank"
      rel="noopener noreferrer"
    >
      Support
    </a>{' '}
    if the problem persists.
  </span>
);

export const requiredErrorMsg = 'This field is required.';
